// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"187":"a0e8f25d","213":"783a474c"}[chunkId] + ".chunk.js";
};